import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const vulcansolseldConfig: TSPConfig = {
  key: 'vulcansolseld',
  name: 'Vulcansols ELD',
  imageName: 'vulcansolseld',
  category: TSPCategory.API_KEY,
  helpText: 'Enter your Vulcansols ELD API key to connect your account.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default vulcansolseldConfig;
